import { useParams } from "react-router";
import BResourcePage from "../../../components/resources/BResourcePage";

const MaklerPropertiesPage = () => {
  const params = useParams();

  return <BResourcePage title={"Immobilien"} url={`/Brokers/admin/${params.id}/properties`} />;
}

export default MaklerPropertiesPage;